import { Badge, Box, Flex, SimpleGrid, Text } from '@chakra-ui/react';

import { CheckMarkIcon } from '@assets/icons';
import Summary from './summary';
import DetailSelloutCard from './card';
import { useMainState } from '@pages/AuditTrailSellOut/state/state';
import { getStatusColor } from '@pages/AuditTrailSellOut/helpers/getStatusColor';

export default function Sellout() {
    const { selectedAuditTrail } = useMainState();

    const selloutData = [
        {
            title: 'Sellout Date',
            content: <Text>{selectedAuditTrail?.date_sellout?.join(', ') ?? '-'}</Text>,
        },
        {
            title: 'Upload Type',
            content: (
                <Flex alignItems="center" gap={2}>
                    {selectedAuditTrail?.upload_type ?? '-'}
                    {selectedAuditTrail?.is_edit && (
                        <Flex alignItems="center" gap={1} color="neutral.500">
                            (Edited
                            <CheckMarkIcon color="#999999" />)
                        </Flex>
                    )}
                </Flex>
            ),
        },
        {
            title: 'Status',
            content: (
                <Badge colorScheme={getStatusColor(selectedAuditTrail?.status)} textTransform={'capitalize'}>
                    {selectedAuditTrail?.status ?? '-'}
                </Badge>
            ),
        },
        {
            title: 'Sellout Type',
            content: <Text>{selectedAuditTrail?.type_date ?? '-'}</Text>,
        },
        {
            title: 'Uploader',
            content: <Text>{selectedAuditTrail?.nama_outlet ?? '-'}</Text>,
        },
        {
            title: 'Timestamp',
            content: <Text>{selectedAuditTrail?.date_uploaded ?? '-'}</Text>,
        },
    ];

    return (
        <Box>
            <SimpleGrid columns={3} spacing={4}>
                {selloutData.map((item, index) => (
                    <DetailSelloutCard key={index} {...item} />
                ))}
            </SimpleGrid>

            <Summary />
        </Box>
    );
}
